export enum RotationCandidateParticipation {
	won = 'won',
	lost = 'lost',
	pending = 'pending',
	no = 'no',
}